import { createAction, handleActions } from 'redux-actions'

const setActiveTab = createAction('SCREENS/SUB_PROJECT/SET_ACTIVE_TAB')
const resetActiveTab = createAction('SCREENS/SUB_PROJECT/RESET_ACTIVE_TAB')

const defaultState = 'OVERVIEW'

const reducer = handleActions(
  {
    [setActiveTab]: (state, { payload }) => payload,
    [resetActiveTab]: () => defaultState,
  },
  defaultState,
)

export { setActiveTab, resetActiveTab, reducer }
